import React, { useEffect, useMemo, useState } from "react";
import { generatePassword, setPasswordLength } from "../../utils/Helper";
import Checkbox from "../elements/checkbox/Checkbox";
import Slider from "../elements/slider/Slider";
import "./Container.css";

const CHECKBOX_LIST = [
  {
    id: 0,
    name: "uppercase",
    label: "Uppercase",
    isChecked: true,
  },
  {
    id: 1,
    name: "lowercase",
    label: "Lowercase",
    isChecked: true,
  },
  {
    id: 2,
    name: "symbols",
    label: "Symbols",
    isChecked: true,
  },
  {
    id: 3,
    name: "numbers",
    label: "Numbers",
    isChecked: true,
  },
];

const Container = (props) => {
  const [rangeValue, setRangeValue] = useState(12);
  const [checkbox, setCheckbox] = useState({
    uppercase: true,
    lowercase: true,
    symbols: true,
    numbers: true,
  });

  const [checked, setChecked] = useState(false);
  const [checkedName, setCheckedName] = useState("");
  const [minMaxValu, setMinMaxValue] = useState({
    min: 1,
    max: 60,
  });

  const { setPassword, setRange, setPasswordProps, type } = props;

  const { uppercase, lowercase, symbols, numbers } = checkbox;
  const { min, max } = minMaxValu;

  useEffect(() => {
    setPasswordLength(rangeValue);
    setRange(rangeValue);
    setRangeValue(rangeValue);
    passwordGenerated(checkbox, rangeValue);
    checkBoxCount();

    //eslint-disable-next-line
  }, [uppercase, lowercase, symbols, numbers]);

  const checkBoxCount = () => {
    const checkCount = Object.keys(checkbox).filter((key) => checkbox[key]);

    const disabled = checkCount.length === 1;
    const name = checkCount[0];

    if (disabled) {
      setChecked(disabled);
      setCheckedName(name);
    } else {
      setChecked(false);
      setCheckedName("");
    }
  };

  const updateCheckBoxes = () => {
    if (type === "pin") {
      CHECKBOX_LIST.map((checkbox) => {
        const name = checkbox.name;
        if (name !== "numbers") {
          checkbox.isChecked = false;
          const checkboxProps = {
            name,
            checkedName: name,
            checked: true,
            isChecked: checkbox.isChecked,
            min: 0,
            max: 15,
            length: 3,
          };
          checkBoxProperties(checkboxProps);
        }
        return "";
      });
    } else {
      CHECKBOX_LIST.map((checkbox) => {
        const name = checkbox.name;

        checkbox.isChecked = true;
        const checkboxProps = {
          name,
          checkedName: "",
          checked: false,
          isChecked: checkbox.isChecked,
          min: 1,
          max: 60,
          length: 3,
        };
        checkBoxProperties(checkboxProps);

        return "";
      });
    }
  };

  const checkBoxProperties = (checkBoxProps) => {
    const { name, checked, isChecked, checkedName, min, max, length } =
      checkBoxProps;
    setCheckbox((prevState) => ({
      ...prevState,
      [name]: isChecked,
    }));
    setChecked(checked);
    setCheckedName(checkedName);
    setPasswordLength(length);
    setMinMaxValue({ min, max });
    setRangeValue(length);
    setRange(length);
  };

  useMemo(updateCheckBoxes, [type]);

  const passwordGenerated = (checkbox, rangeValue) => {
    const pwd =
      rangeValue === 0 && rangeValue > 3
        ? generatePassword(checkbox, rangeValue)
        : generatePassword(checkbox, 3);
    setPassword(pwd);
    setPasswordProps(checkbox);
  };

  const onChangeSlider = (e) => {
    // console.log(e.target.value);

    setRangeValue(e.target.value);
    setPasswordLength(e.target.value);
    setRange(e.target.value);
    passwordGenerated(checkbox, e.target.value);
  };

  const onChangeCheckbox = (e) => {
    if (type !== "pin") {
      // console.log(e.target.value);
      const { name, checked } = e.target;

      CHECKBOX_LIST.map((checkbox) => {
        if (checkbox.name === name) {
          checkbox.isChecked = checked;
          // setCheckbox({ [name]: checkbox.isChecked });
          setCheckbox((prevState) => ({
            ...prevState,
            [name]: checkbox.isChecked,
          }));
          setPasswordLength(rangeValue);
          setRangeValue(rangeValue);
        }

        return "";
      });
    }
  };

  return (
    <div>
      <div className="password-settings">
        <h3>use the slider and select from the options</h3>

        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              &nbsp;
              <Slider
                min={parseInt(min, 10)}
                max={parseInt(max, 10)}
                step={1}
                value={parseInt(rangeValue, 10)}
                defaultLength={parseInt(rangeValue, 10)}
                onChangeValue={onChangeSlider}
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="row checkbox-container">
              {CHECKBOX_LIST.map((checkbox) => (
                <Checkbox
                  key={checkbox.id}
                  name={checkbox.name}
                  checked={checkbox.isChecked}
                  label={checkbox.label}
                  value={checkbox.isChecked}
                  onChange={onChangeCheckbox}
                  disabled={
                    checked &&
                    checkbox.isChecked &&
                    checkedName === checkbox.name
                  }
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Container };
